import { c as _c } from "react/compiler-runtime";
import { ButtonBase, Stack } from "@mui-wrapper";
import { Text, Tooltip, useToast } from "@flat-ui";
import { AnnotationSidePanelEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { copyToClipboard } from "@utils/ui-utils";
/**
 * Renders an annotation measurement value
 */
export function MarkupMeasurement(t0) {
  const $ = _c(24);
  const {
    value,
    tooltip,
    icon,
    label,
    copiedTitle: t1,
    trackingSection: t2
  } = t0;
  const copiedTitle = t1 === undefined ? "Measurement copied" : t1;
  const trackingSection = t2 === undefined ? "measurementValues" : t2;
  const {
    openToast
  } = useToast();
  const {
    trackEvent
  } = useTrackEvent();
  let t3;
  if ($[0] !== copiedTitle || $[1] !== openToast || $[2] !== tooltip || $[3] !== trackEvent || $[4] !== trackingSection || $[5] !== value) {
    t3 = function copyValue() {
      copyToClipboard(value);
      openToast({
        title: copiedTitle
      });
      trackEvent({
        name: AnnotationSidePanelEvents.copyValue,
        props: {
          section: trackingSection,
          value: tooltip
        }
      });
    };
    $[0] = copiedTitle;
    $[1] = openToast;
    $[2] = tooltip;
    $[3] = trackEvent;
    $[4] = trackingSection;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const copyValue = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      flexDirection: "row",
      alignItems: "center",
      gap: 2
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== label) {
    t5 = label && <Text variant="bodyS" sx={{
      mr: "auto"
    }}>{label}</Text>;
    $[8] = label;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== icon || $[11] !== tooltip) {
    t6 = <Tooltip title={tooltip}>{icon}</Tooltip>;
    $[10] = icon;
    $[11] = tooltip;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = `Copy ${tooltip}`;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      borderRadius: 0.5,
      "&:hover, &:focus-visible": {
        textDecoration: "underline"
      }
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== value) {
    t9 = <Text variant="bodyS" component="var">{value}</Text>;
    $[14] = value;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== copyValue || $[17] !== t7 || $[18] !== t9) {
    t10 = <Tooltip title="Copy value"><ButtonBase onClick={copyValue} aria-label={t7} sx={t8}>{t9}</ButtonBase></Tooltip>;
    $[16] = copyValue;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5 || $[22] !== t6) {
    t11 = <Stack sx={t4}>{t5}{t6}{t10}</Stack>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t6;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}